export const ORG_SEARCH_FORM_NAME = 'ordersOrgSearch'
export const ORG_SEARCH_FIELD_NAME = 'ordersOrgName'
export const ORG_SEARCH_FIELD_ID = 'ordersOrgId'
export const ORG_SEARCH_FIELD_AICODE = 'ordersAICode'
